import React from "react";

import { PackagesReportFilter } from "./PackagesReportFilter";
import { PackagesReportSummary } from "./PackagesReportSummary";
import { PackagesReportTable } from "./PackagesReportTable";

export function PackagesReport() {
  return (
    <div className="flex w-full flex-col gap-5 pt-5">
      <PackagesReportFilter />
      <PackagesReportSummary />
      <PackagesReportTable />
    </div>
  );
}
